import { IAIProvider } from './interfaces/IAIProvider';
import { VertexAIProvider } from './vertex/VertexAIProvider';
import { log } from '../../utils/logging';

export type ProviderType = 'vertex';

export function createAIProvider(type: ProviderType = 'vertex'): IAIProvider {
  log(`Creating AI provider: ${type}`);
  
  switch (type) {
    case 'vertex':
      return new VertexAIProvider();
    default:
      throw new Error(`Unknown AI provider type: ${type}`);
  }
}

